export const VALID_GUESSES = [
  'aaide',
  'aaien',
  'aaier',
  'aailt',
  'aales',
  'aalge',
  'aalke',
  'aalle',
  'aambo',
  'aande',
  'aanje',
  'aanke',
  'aanko',
  'aanno',
  'aarde',
  'aarem',
  'aarfd',
  'aarke',
  'aarme',
  'aarms',
  'aarns',
  'aarvn',
  'aaske',
  'abuus',
  'achte',
  'acter',
  'actie',
  'adder',
  'admis',
  'adres',
  'afzit',
  'agent',
  'aibal',
  'aibel',
  'aiber',
  'aibor',
  'aiden',
  'aigen',
  'aiken',
  'aineg',
  'ainig',
  'ainlk',
  'aisse',
  'aiweg',
  'aiwen',
  'akker',
  'aksie',
  'akten',
  'akter',
  'alarm',
  'albai',
  'alder',
  'aldus',
  'aleer',
  'alens',
  'alhou',
  'alien',
  'allen',
  'aller',
  'alles',
  'alloc',
  'allor',
  'allos',
  'alsof',
  'alzoo',
  'ameri',
  'amoal',
  'among',
  'amour',
  'amper',
  'anden',
  'ander',
  'andor',
  'angel',
  'angol',
  'angst',
  'anjes',
  'anker',
  'ankom',
  'annem',
  'annie',
  'annoa',
  'ansen',
  'antje',
  'aobel',
  'aodam',
  'aolds',
  'aoldt',
  'aolen',
  'aolle',
  'aollu',
  'aorde',
  'aoreg',
  'aorig',
  'aosem',
  'aozem',
  'apart',
  'appel',
  'appie',
  'april',
  'arbai',
  'arbor',
  'arend',
  'arger',
  'armen',
  'armer',
  'armke',
  'armon',
  'arten',
  'artis',
  'arven',
  'asmis',
  'assen',
  'astoe',
  'atmis',
  'atten',
  'augen',
  'avait',
  'avant',
  'avens',
  'avent',
  'avond',
  'azzen',
  'azzer',
  'baaid',
  'baalg',
  'baalk',
  'baand',
  'baang',
  'baank',
  'baard',
  'baarg',
  'baark',
  'baarm',
  'baauw',
  'badde',
  'badje',
  'bagel',
  'baide',
  'baier',
  'baist',
  'bakje',
  'baksk',
  'bakte',
  'banen',
  'bange',
  'baone',
  'baord',
  'baren',
  'barge',
  'bargt',
  'barre',
  'barst',
  'barte',
  'barts',
  'baten',
  'batse',
  'batsk',
  'bauen',
  'bauwd',
  'bauwt',
  'bedee',
  'beden',
  'beder',
  'bedie',
  'bedje',
  'bedon',
  'bedur',
  'beduu',
  'beeld',
  'beele',
  'beere',
  'beets',
  'begev',
  'begin',
  'begon',
  'begun',
  'begut',
  'behen',
  'beide',
  'beist',
  'bekee',
  'beken',
  'beket',
  'bekje',
  'belde',
  'belet',
  'belle',
  'beloa',
  'benao',
  'bende',
  'bened',
  'benje',
  'benne',
  'benul',
  'bepke',
  'beppe',
  'berde',
  'bered',
  'berek',
  'beren',
  'berij',
  'beris',
  'beroa',
  'berre',
  'besef',
  'besta',
  'beste',
  'beten',
  'beter',
  'betje',
  'betor',
  'beune',
  'beurd',
  'beurt',
  'beuze',
  'bevol',
  'bezat',
  'bezem',
  'bezig',
  'bezit',
  'bibel',
  'bidde',
  "bie'n",
  'biele',
  'biene',
  'biets',
  'bigge',
  'bijer',
  'bijna',
  'bille',
  'bindt',
  'binne',
  'binnn',
  'binoa',
  'biste',
  'bitte',
  'bladz',
  'blaik',
  'blank',
  'blast',
  'blauw',
  'bleef',
  'bleek',
  'bleet',
  'bleik',
  'blend',
  'blets',
  'bleut',
  'blied',
  'blief',
  'bliek',
  'blier',
  'bliev',
  'blifs',
  'blift',
  'blind',
  'blink',
  'bloak',
  'bloar',
  'bloas',
  'blode',
  'bloed',
  'bloes',
  'bloet',
  'blonk',
  'bloot',
  'blosz',
  'bloud',
  'bloum',
  'blout',
  'bluis',
  'bluit',
  'boake',
  'boale',
  'boane',
  'board',
  'boare',
  'boars',
  'boast',
  'bocht',
  'bodde',
  'boden',
  'boeke',
  'boele',
  'boerd',
  'boers',
  'boete',
  'boeze',
  'bogen',
  'boien',
  'bokke',
  'bokst',
  'bolde',
  'bolle',
  'bolsk',
  'bomen',
  'bomke',
  'bonde',
  'bonen',
  'bonke',
  'bonst',
  'bonte',
  'bonus',
  'boome',
  'boord',
  'boren',
  'borge',
  'borre',
  'borst',
  'bosch',
  'bosen',
  'boske',
  'boter',
  'botte',
  'bouke',
  'boukj',
  'boule',
  'boute',
  'bouwd',
  'bouwt',
  'boven',
  'bozem',
  'braam',
  'bradt',
  'braid',
  'braif',
  'braiv',
  'brams',
  'brand',
  'brave',
  'breed',
  'breid',
  'breie',
  'brekt',
  'breng',
  'breuk',
  'bried',
  'brief',
  'briek',
  'bries',
  'brijf',
  'brikk',
  'brill',
  'brink',
  'broad',
  'broak',
  'broam',
  'broch',
  'brods',
  'broed',
  'broek',
  'broen',
  'broer',
  'broes',
  'brogg',
  'brogt',
  'bromd',
  'bromt',
  'brood',
  'broot',
  'brouk',
  'bruds',
  'bruil',
  'bruin',
  'bruir',
  'bruis',
  'bruit',
  'bruud',
  'bruuk',
  'bruun',
  'bruur',
  'bugen',
  'buien',
  'buift',
  'buike',
  'buite',
  'bukte',
  'bulde',
  'bulen',
  'bult5',
  'bulte',
  'bunen',
  'bunne',
  'bunze',
  'buren',
  'busch',
  'buten',
  'buter',
  'butje',
  'buuls',
  'buurt',
  'buuts',
  'buzze',
  'carre',
  'cents',
  'chais',
  'chelk',
  'chien',
  'chris',
  'comga',
  'coord',
  'daait',
  'daank',
  'daard',
  'daarg',
  'daarm',
  'daauw',
  'dacht',
  'dadde',
  'daden',
  'dadls',
  'daems',
  'dafur',
  'dagen',
  'daier',
  'daige',
  'daild',
  'dails',
  'daimt',
  'daind',
  'daint',
  'daipe',
  'daips',
  'dajje',
  'dames',
  'dampt',
  'danke',
  'danst',
  'daoge',
  'daogs',
  'daome',
  'darde',
  'dareg',
  'dasse',
  'daste',
  "dat'n",
  "dat's",
  'datis',
  'datje',
  'datst',
  'datte',
  'datum',
  'david',
  'dazze',
  'debet',
  'decht',
  'deden',
  'dedst',
  'deeen',
  'deegs',
  'deele',
  'deels',
  'deelt',
  'deest',
  'deide',
  'deien',
  'deier',
  'deine',
  'deist',
  'deken',
  'dekte',
  'delen',
  'delft',
  'delle',
  'delte',
  'demie',
  'demon',
  'denis',
  'denkt',
  'denne',
  'derde',
  'derge',
  'derij',
  'detje',
  'deuen',
  'deugd',
  'deugt',
  'deuks',
  'deupt',
  'deure',
  'deurs',
  'deuze',
  'dezen',
  'dezer',
  'dezes',
  'dicht',
  'didde',
  'dieks',
  'dient',
  'diepe',
  'dijen',
  'dijer',
  'dijnt',
  'dikke',
  'dikte',
  'diner',
  'dings',
  'dioak',
  'disse',
  'ditje',
  'dizze',
  'doage',
  'doags',
  'doale',
  'doals',
  'doame',
  'doato',
  'dobbe',
  'dochs',
  'docht',
  'dodde',
  'doede',
  'doeht',
  'doeme',
  'doene',
  'doent',
  'doest',
  'doeve',
  'dofte',
  'dogst',
  'dokeg',
  'doken',
  'dokse',
  'dolen',
  'dolle',
  'domee',
  'domie',
  'domme',
  'dompe',
  'donde',
  'doode',
  'doods',
  'dooic',
  'dooie',
  'doord',
  'doorn',
  'doovc',
  'doove',
  'dopte',
  'dordt',
  'dorie',
  'dorms',
  'dorst',
  "dou's",
  "dou't",
  'douwe',
  "dr'op",
  'draad',
  'draai',
  'draal',
  'draft',
  'dragt',
  'draig',
  'drait',
  'drank',
  'drans',
  'draod',
  'draog',
  'drbie',
  'dreef',
  'dreeg',
  'dreie',
  'dreje',
  'dreld',
  'drels',
  'drent',
  'dreug',
  'dreum',
  'dreve',
  'driee',
  'drief',
  'drift',
  'drije',
  'drijf',
  'drink',
  'drint',
  'droad',
  'droag',
  'droak',
  'droef',
  'droes',
  'droet',
  'drogt',
  'drokt',
  'dronk',
  'droom',
  'drost',
  'droud',
  'droug',
  'drous',
  'druig',
  'drukt',
  'drupt',
  'druuf',
  'ducht',
  'dudel',
  'duden',
  'dugst',
  'dugte',
  'duien',
  'duize',
  'duken',
  'duker',
  'dulek',
  'dumas',
  'dunen',
  'dunkt',
  'dunne',
  'durch',
  'dureg',
  'duren',
  'durft',
  'durig',
  'duste',
  'duurd',
  'duurt',
  'duust',
  'duuts',
  'duvel',
  'duvol',
  'duzen',
  'dwaas',
  'dwang',
  'dwars',
  'dwelm',
  'dwoas',
  'ebbel',
  'ebben',
  'echte',
  'edele',
  'edzes',
  'eelsk',
  'eenen',
  'eener',
  'eenig',
  'eerde',
  'eeren',
  'eerns',
  'eerst',
  'eeten',
  'efkes',
  'eggen',
  'ehmen',
  'eifer',
  'eigen',
  'einde',
  'einem',
  'einer',
  'eisch',
  'eisso',
  'ekkel',
  'elfde',
  'elfte',
  'elken',
  'elle-',
  'ellen',
  'elpen',
  'elske',
  'elsme',
  'eltje',
  'eltjo',
  'elven',
  'emeln',
  'emmen',
  'emmer',
  'endel',
  'enden',
  'endje',
  'eneer',
  'enens',
  'engel',
  'enkel',
  'enneg',
  'enter',
  'epres',
  'erelk',
  'erger',
  'erkes',
  'ervan',
  'essen',
  'etens',
  'etter',
  'etwas',
  'etwig',
  'etwoa',
  'eulen',
  'eulie',
  'eulje',
  'euvel',
  'evens',
  'evert',
  'evven',
  'extra',
  'faail',
  'faait',
  'faarm',
  'famke',
  'farms',
  'feeen',
  'feest',
  'feine',
  'fekke',
  'felle',
  'femoa',
  'fens0',
  'ferst',
  'fffft',
  'fiene',
  'fiets',
  'fikke',
  'fikse',
  'filet',
  'finge',
  'fioel',
  'fioul',
  'firma',
  'flaar',
  'flare',
  'flaue',
  'flauw',
  'fleeg',
  'fleer',
  'flekt',
  'fleur',
  'flier',
  'flink',
  'floep',
  'floit',
  'flonk',
  'flont',
  'flopt',
  'flort',
  'fluit',
  'foeke',
  'foeks',
  'fokke',
  'fokse',
  'foske',
  'fosse',
  'fotse',
  'fpiet',
  'frans',
  'franz',
  'freue',
  'frits',
  'fritz',
  'fromm',
  'frund',
  'ftaan',
  'ftait',
  'ftoul',
  'gaaie',
  'gaail',
  'gaais',
  'gaait',
  'gaalg',
  'gaang',
  'gaans',
  'gaard',
  'gaasp',
  'gaast',
  'gaauw',
  'gafst',
  'gaist',
  'galop',
  'gange',
  'ganke',
  'ganze',
  'gaoie',
  'gaold',
  'gaore',
  'gaove',
  'gapse',
  'gapte',
  'garen',
  'garmt',
  'garre',
  'garst',
  'gaten',
  'gatje',
  'gebed',
  'geben',
  'gebod',
  'gedag',
  'gedoe',
  'gedou',
  'geeft',
  'geele',
  'geern',
  'geert',
  'geest',
  'gefst',
  'gehad',
  'gehak',
  'gekke',
  'gelag',
  'gelde',
  'geldt',
  'gelok',
  'geluk',
  'gemak',
  'genai',
  'genog',
  'genot',
  'genut',
  'gepke',
  'gepse',
  'gerak',
  'gerde',
  'gereg',
  'geren',
  'gerib',
  'gerst',
  'geste',
  'getee',
  'geten',
  'getie',
  'getik',
  'geude',
  'geurs',
  'geute',
  'geval',
  'gevel',
  'geven',
  'gever',
  'gewag',
  'gewin',
  'gewon',
  'gewor',
  'gezag',
  'gezet',
  'gezin',
  'giebt',
  'giene',
  'giert',
  'giesp',
  'gilde',
  'gille',
  'gingt',
  'glaai',
  'glaas',
  'glad0',
  'glans',
  'gleer',
  'glenz',
  'glidt',
  'glief',
  'glimt',
  'glins',
  'glipt',
  'gloep',
  'gloop',
  'glots',
  'gloud',
  'gluup',
  'gnuut',
  'goarn',
  'gobbe',
  'gobse',
  'goede',
  'goedt',
  'goeie',
  'goeje',
  'goele',
  'goert',
  'goeze',
  'goije',
  'golag',
  'golve',
  'gongk',
  'gonog',
  'gooid',
  'gooin',
  'gooit',
  'gorde',
  'gorte',
  'goten',
  'goude',
  'gouds',
  'gouie',
  'gouje',
  'goujn',
  'goval',
  'gozen',
  'graag',
  'graas',
  'graft',
  'grage',
  'grait',
  'grata',
  'grauw',
  'greep',
  'grees',
  'grens',
  'grenz',
  'greun',
  'griep',
  'gries',
  'griet',
  'grimd',
  'grins',
  'grint',
  'gript',
  'groag',
  'groas',
  'groat',
  'groav',
  'grode',
  'groen',
  'groep',
  'groes',
  'groet',
  'grond',
  'gronn',
  'groot',
  'groth',
  'grouf',
  'groul',
  'group',
  'grout',
  'grude',
  'gruid',
  'gruin',
  'gruit',
  'grunn',
  'grusz',
  'gruus',
  'guano',
  'gudeg',
  'gugel',
  'guido',
  'guise',
  'gulbe',
  'gulen',
  'gulle',
  'gunde',
  'gunne',
  'gunst',
  'guteg',
  'haaid',
  'haail',
  'haalf',
  'haals',
  'haalt',
  'haand',
  'haard',
  'haark',
  'haarm',
  'haars',
  'haart',
  'haast',
  'haaud',
  'haauw',
  'haide',
  'haike',
  'haile',
  'hailn',
  'hailo',
  'haist',
  'haite',
  'hajje',
  'hakje',
  'hakke',
  'halen',
  'halve',
  'hands',
  'hangt',
  'hanko',
  'haoke',
  'haold',
  'haoln',
  'haolt',
  'haone',
  'haost',
  'haoze',
  'hapke',
  'harde',
  'haren',
  'harer',
  'harin',
  'harje',
  'harke',
  'harmo',
  'harms',
  'harre',
  'harry',
  'harst',
  'harte',
  'haste',
  'hatte',
  'haude',
  'hauen',
  'hausl',
  'hauwt',
  'haver',
  'hebbe',
  'hecht',
  'heden',
  'heeft',
  'heekt',
  'heele',
  'heelt',
  'heerd',
  'heere',
  'heern',
  'heert',
  'hegen',
  'heger',
  'heile',
  'heisz',
  'hekel',
  'hekje',
  'hekse',
  'helft',
  'helle',
  'helpt',
  'hemel',
  'hemen',
  'hemmn',
  'henin',
  'henje',
  'heren',
  'hergn',
  'herin',
  'herom',
  'herst',
  'herum',
  'heste',
  'hetje',
  'hette',
  'heuen',
  'heufd',
  'heugt',
  'heurd',
  'heurs',
  'heurt',
  'hezze',
  'hield',
  'hielp',
  'hijle',
  'hijte',
  'hilje',
  'hilte',
  'hinkt',
  'hinne',
  'hirre',
  'hitje',
  'hoabe',
  'hoaks',
  'hoald',
  'hoalt',
  'hoane',
  'hoast',
  'hoats',
  'hoaze',
  'hocht',
  'hoeft',
  'hoeke',
  'hoele',
  'hoera',
  'hoesg',
  'hogen',
  'hoger',
  'hogte',
  'hohen',
  'hoile',
  'hokje',
  'holde',
  'holdt',
  'holle',
  'holst',
  'hom12',
  'home1',
  'home2',
  'homko',
  'hompe',
  'honde',
  'honds',
  'hoofd',
  'hooge',
  'hoopt',
  'hoord',
  'hoorn',
  'hoort',
  'hoose',
  'hopen',
  'horde',
  'horen',
  'horns',
  'horre',
  'horst',
  'hosen',
  'hospi',
  'hotel',
  'houdt',
  'houer',
  'hougd',
  'hougt',
  'houks',
  'houon',
  'houst',
  'houte',
  'hozen',
  'hudde',
  'huder',
  'hufde',
  'hugen',
  'huifs',
  'huift',
  'huila',
  'huilp',
  'huilt',
  'huken',
  'hulpe',
  'hulst',
  'hulze',
  'hunne',
  'huppe',
  'huren',
  'hurre',
  'husie',
  'hutje',
  'huurd',
  'huurt',
  'huusi',
  'huven',
  'huver',
  'huzen',
  'iaand',
  'iedel',
  'ieder',
  'iedor',
  'iegel',
  'iegen',
  'ieken',
  'iekje',
  'iekte',
  'ielte',
  'iemeg',
  'iemen',
  'iesde',
  'ieveg',
  'iever',
  'iezel',
  'iezen',
  'iezer',
  'iezor',
  'ihnen',
  'ihrer',
  'iiekt',
  'ijden',
  'ijgen',
  'ijske',
  'ijwig',
  'immer',
  'inain',
  'inaor',
  'indie',
  'ineen',
  'infer',
  'injes',
  'inket',
  'inner',
  'innig',
  'inoar',
  'inrit',
  'insen',
  'inter',
  'inwyd',
  'inzag',
  'inzen',
  'inzet',
  'inzit',
  'iĳwig',
  'jaape',
  'jaase',
  'jacht',
  'jacke',
  'jacob',
  'jagst',
  'jaogd',
  'jaren',
  'jaske',
  'jasse',
  'jawel',
  'jawol',
  'jazen',
  'jazes',
  'jazze',
  'jedem',
  'jeden',
  'jeder',
  'jenes',
  'jenny',
  'jeude',
  'jeugd',
  'jeuze',
  'jezer',
  'jezus',
  'jiere',
  'jirre',
  'joabk',
  'joagd',
  'joagt',
  'joane',
  'joapk',
  "joe't",
  'joepe',
  'jonge',
  'jongs',
  'joost',
  'josse',
  'joune',
  'juist',
  'jurie',
  'jurns',
  'juust',
  'kaalf',
  'kaalk',
  'kaalm',
  'kaamp',
  'kaand',
  'kaans',
  'kaant',
  'kaarf',
  'kaars',
  'kaart',
  'kaast',
  'kaauw',
  'kabbe',
  'kadde',
  'kaier',
  'kaisd',
  'kaiwe',
  'kakel',
  'kakje',
  'kakke',
  'kamer',
  'kamme',
  'kanen',
  'kanne',
  'kanst',
  'kante',
  'kants',
  'kaode',
  'kaoen',
  'kaold',
  'kaole',
  'kaoll',
  'kaore',
  'kapje',
  'kapot',
  'kappe',
  'kaput',
  'karaf',
  'karre',
  'karro',
  'katje',
  'katte',
  'kaude',
  'kebof',
  'kecht',
  'kedde',
  'kedel',
  'keerd',
  'keerl',
  'keern',
  'keers',
  'keert',
  'keese',
  'kegel',
  'keine',
  'kejak',
  'keken',
  'kelen',
  'kelke',
  'keloa',
  'kemde',
  'kende',
  'kenne',
  'kenon',
  'kenst',
  'kenze',
  'kepot',
  'kerde',
  'kerei',
  'kerel',
  'keren',
  'kerij',
  'kerke',
  'kerol',
  'kerrr',
  'ketel',
  'keuze',
  'kevot',
  'kidde',
  'kiebe',
  'kiebt',
  'kieft',
  'kiekn',
  'kiekt',
  'kiels',
  'kiend',
  'kiepe',
  'kieuw',
  'kieve',
  'kiffe',
  'kifke',
  'kijke',
  'kijkt',
  'kikst',
  'kille',
  'kilte',
  'kinds',
  'kinne',
  'kipen',
  'kippe',
  'kiros',
  'kirre',
  'kiste',
  'klaai',
  'klaar',
  'klabt',
  'klaid',
  'klain',
  'klair',
  'klamp',
  'klank',
  'klant',
  'klaor',
  'klaos',
  'klapp',
  'klapt',
  'klare',
  'klatr',
  'klaus',
  'kleed',
  'klein',
  'klerk',
  'klets',
  'kleuf',
  'kleun',
  'kleur',
  'klied',
  'klief',
  'klien',
  'klijt',
  'klink',
  'klins',
  'klinz',
  'klits',
  'kloag',
  'kloar',
  'kloas',
  'kloef',
  'kloet',
  'kloks',
  'klomm',
  'klomp',
  'klonk',
  'klont',
  'kloon',
  'klopt',
  'kloug',
  'klouk',
  'kloun',
  'klove',
  'kluig',
  'kluit',
  'kluuf',
  'kluun',
  'kluut',
  'knaar',
  'knage',
  'knaol',
  'knapt',
  'knare',
  'knauw',
  'kneel',
  'kneep',
  'kneie',
  'knief',
  'knien',
  'kniep',
  'knije',
  'knikt',
  'knipt',
  'knirt',
  'knoak',
  'knoal',
  'knobe',
  'knooi',
  'knoop',
  'knupt',
  'knuur',
  'knuut',
  'koahn',
  'koale',
  'koane',
  'koare',
  'koart',
  'kobbe',
  'kobus',
  'koele',
  'koeme',
  'koers',
  'koert',
  'koest',
  'koete',
  'koeze',
  'koffe',
  'kofje',
  'kofst',
  'kofte',
  'koier',
  'kojen',
  'koken',
  'koker',
  'kolde',
  'kolen',
  'kolle',
  "kom'n",
  'koman',
  'komen',
  'komke',
  'komme',
  'komoa',
  'komsa',
  'komst',
  'konde',
  'konnt',
  'konst',
  'konze',
  'kookt',
  'koomt',
  'koope',
  'koopt',
  'koors',
  'kopen',
  'koper',
  'kopje',
  'kopke',
  'kopot',
  'kopte',
  'korde',
  'koren',
  'korke',
  'korst',
  'korte',
  'korts',
  'koste',
  'kouke',
  'kozen',
  'kraab',
  'kraai',
  'kraak',
  'kraal',
  'kraan',
  'krabe',
  'krabt',
  'krach',
  'krale',
  'krang',
  'krank',
  'krant',
  'kraog',
  'kraom',
  'kraon',
  'kreeg',
  'kreet',
  'krekt',
  'kreul',
  'kreus',
  'kreut',
  'krieg',
  'kriet',
  'krigs',
  'krigt',
  'krije',
  'krijg',
  'krijt',
  'krimp',
  'kring',
  'krint',
  'kroag',
  'kroak',
  'kroam',
  'kroan',
  'krode',
  'kroeg',
  'kroek',
  'kroem',
  'kroep',
  'kroes',
  'kromp',
  'krood',
  'kroop',
  'kroos',
  'kropt',
  'krosz',
  'kroug',
  'kroun',
  'kruid',
  'kruud',
  'kruuk',
  'kruul',
  'kruun',
  'kruus',
  'kruut',
  'kscht',
  'kubbe',
  'kudde',
  'kuien',
  'kuier',
  'kuken',
  'kummt',
  'kunde',
  'kunne',
  'kunst',
  'kureg',
  'kuren',
  'kuske',
  'kuten',
  'kutes',
  'kuus!',
  'kveur',
  'kwaab',
  'kwaad',
  'kwaal',
  'kwabe',
  'kwabs',
  'kwakt',
  'kwalm',
  'kwamm',
  'kwamt',
  'kwani',
  'kwaod',
  'kwart',
  'kwast',
  'kweek',
  'kween',
  'kweer',
  'kwene',
  'kwiel',
  'kwiet',
  'kwijt',
  'kwink',
  'kwint',
  'kwoad',
  'kwoal',
  'kwoam',
  'kwoat',
  'laaip',
  'laamp',
  'laand',
  'laang',
  'laank',
  'laans',
  'laarp',
  'laauw',
  'labbe',
  'lacht',
  'ladde',
  'laden',
  'lagen',
  'lagte',
  'laidj',
  'laidt',
  'laifd',
  'laik2',
  'laind',
  'lains',
  'laisk',
  'laist',
  'laite',
  'laive',
  'laivm',
  'laiwe',
  'lampe',
  'lande',
  'langd',
  'lange',
  'langs',
  'langt',
  'laoge',
  'laone',
  'lapje',
  'lapke',
  'lappe',
  'lareg',
  'larie',
  'larom',
  'laszt',
  'laten',
  'later',
  'latse',
  'latte',
  'lazen',
  'lebbe',
  'ledeg',
  'leden',
  'leder',
  'ledig',
  'leefd',
  'leeft',
  'leege',
  'leerd',
  'leers',
  'leert',
  'leesd',
  'leest',
  'leeuw',
  'legde',
  'legen',
  'leger',
  'legge',
  'legio',
  'legst',
  'leide',
  'leive',
  'leken',
  'lekje',
  'lekst',
  'lekte',
  'lelie',
  'lelke',
  'lelle',
  'lelns',
  'leman',
  'lende',
  'lepel',
  'leren',
  'leste',
  'letst',
  'lette',
  'leufd',
  'leufk',
  'leuft',
  'leuke',
  'leunt',
  'leven',
  'lever',
  'levie',
  'levor',
  'lezen',
  'lezer',
  'lezie',
  'libbe',
  'licht',
  'liebe',
  'liebs',
  'liebt',
  'lieer',
  'liefe',
  'liegt',
  'lieke',
  'lieks',
  'liekt',
  'liene',
  'liept',
  'liere',
  'liest',
  'lieuw',
  'lieve',
  'ligst',
  'ligte',
  'lijas',
  'lijen',
  'lijkt',
  'lijnt',
  'lijte',
  'lijve',
  'lijwe',
  'likse',
  'linde',
  'links',
  'lioog',
  'lirom',
  'liter',
  'litse',
  'liwer',
  'loage',
  'loane',
  'loate',
  'lobbe',
  'locht',
  'lodde',
  'lodeg',
  'loden',
  'loeks',
  'loens',
  'loert',
  'logen',
  'lokke',
  'lokst',
  'loods',
  'loont',
  'loops',
  'loopt',
  'lopen',
  'loper',
  'lopst',
  'loren',
  'losfe',
  'losse',
  'loste',
  'lotje',
  'lotte',
  'louge',
  'louis',
  'loven',
  'lozee',
  'lubbe',
  'lubke',
  'lucht',
  'luden',
  'lugst',
  'luien',
  'luifk',
  'luipt',
  'luius',
  'lukas',
  'lukte',
  'lunze',
  'luste',
  'lutek',
  'luthe',
  'lutje',
  'luuks',
  'luurs',
  'luutk',
  'luzen',
  'maaid',
  'maakt',
  'maand',
  'maank',
  'maans',
  'maarg',
  'maark',
  'maart',
  'maauw',
  'macht',
  'madde',
  'magel',
  'magen',
  'mager',
  'magst',
  'maier',
  'maind',
  'mains',
  'maint',
  'maist',
  'maive',
  'maiwe',
  'maken',
  'maker',
  'malen',
  'malle',
  'mande',
  'manen',
  'mangs',
  'manje',
  'manlu',
  'manne',
  'maode',
  'maoge',
  'maokt',
  'maond',
  'maone',
  'markt',
  'marse',
  'massa',
  'matsk',
  'matth',
  'medal',
  'medde',
  'meder',
  'media',
  'meent',
  'meere',
  'meert',
  'meest',
  'meeuw',
  'megog',
  'meind',
  'meine',
  'meint',
  'meist',
  'melle',
  'melse',
  'menak',
  'menee',
  'mener',
  'mengt',
  'menig',
  'menne',
  'mensk',
  'mente',
  'menze',
  'meree',
  'meren',
  'merie',
  'merke',
  'meske',
  'meten',
  'meter',
  'metje',
  'mette',
  'meuge',
  'meuje',
  'meuke',
  'mezze',
  'miede',
  'mieds',
  'miend',
  'miens',
  'mient',
  'miere',
  'miest',
  'mijne',
  'mijns',
  'mijst',
  'miles',
  'minen',
  'minne',
  'minoa',
  'minsk',
  'minst',
  'minze',
  'misda',
  'misse',
  'mitte',
  'mizze',
  'moade',
  'moage',
  'moaks',
  'moakt',
  'moand',
  'moane',
  'moars',
  'moate',
  'mocht',
  'modde',
  'model',
  'moder',
  'moeke',
  'moest',
  'mogen',
  'mogst',
  'moien',
  'moije',
  'molle',
  'mooie',
  'moois',
  'mooit',
  'moord',
  'morgn',
  'morns',
  'motte',
  'motto',
  'moude',
  'mouer',
  'mouke',
  'moust',
  'mouwe',
  'mozes',
  'mstor',
  'mudde',
  'mugge',
  'muide',
  'muieg',
  'muien',
  'muike',
  'muite',
  'muive',
  'muren',
  'murre',
  'muske',
  'mutje',
  'mutke',
  'mutse',
  'muure',
  'naaid',
  'naait',
  'naald',
  'naarf',
  'naarm',
  'naast',
  'naauw',
  'nacht',
  'nadat',
  'nadde',
  'nader',
  'naien',
  'nailt',
  'naiti',
  'nakke',
  'namen',
  'nanen',
  'nanne',
  'naost',
  'nareg',
  'naren',
  'narms',
  'natsk',
  'natte',
  'nauwe',
  'ndrns',
  'nebbe',
  'neemt',
  'neerd',
  'neers',
  'nefie',
  'negen',
  'neger',
  'neien',
  'neigt',
  'nekke',
  'nelle',
  'nemen',
  'nemer',
  'nemst',
  'nereg',
  'neren',
  'neten',
  'netje',
  'neude',
  'neust',
  'neuze',
  'nevel',
  'neven',
  'newoa',
  'nhaid',
  'nheer',
  'nicht',
  'nieds',
  'niets',
  'nieuw',
  'nijen',
  'nikoa',
  'nikst',
  'nikte',
  'nioar',
  'nioet',
  'niĳjt',
  'nliek',
  'nmike',
  'nnnna',
  'noach',
  'noame',
  'noast',
  'nocht',
  'nodeg',
  'noemt',
  'nogal',
  'nokje',
  "nom'n",
  'nomen',
  'nooii',
  'nooit',
  'noord',
  'noort',
  'noren',
  'norms',
  'noten',
  'notoa',
  'nslag',
  'nspul',
  'nstuk',
  'nucht',
  'nuigd',
  'nuigt',
  'nuimd',
  'nuimt',
  'numeg',
  'numen',
  'numer',
  'nunen',
  'nuner',
  'nurms',
  'nuvdr',
  'nuver',
  'nuvor',
  'nwigd',
  'oabel',
  'oaber',
  'oadel',
  'oader',
  'oafke',
  'oaker',
  'oalen',
  'oameg',
  'oamel',
  'oamen',
  'oanen',
  'oarde',
  'oareg',
  'oaren',
  'oarig',
  'oazem',
  'ochie',
  'odder',
  'oelen',
  'oemba',
  'oepke',
  'oevon',
  'offer',
  'ofste',
  'oftak',
  'often',
  'ofval',
  'ofvol',
  'ofwis',
  'ofzag',
  'ofzet',
  'ogelk',
  'ohren',
  'okken',
  'olbal',
  'olden',
  'older',
  'oldsk',
  'oling',
  'ollen',
  'oller',
  'olman',
  'olsde',
  'olske',
  'olste',
  'omdat',
  'omdel',
  'omhen',
  'omhon',
  'ommes',
  'ommoi',
  'ommui',
  'ompie',
  'omvlo',
  'omvol',
  'omweg',
  'omzwi',
  'ondcr',
  'onden',
  'onder',
  'ondeu',
  'ondor',
  'ondur',
  'ongel',
  'onkel',
  'onmak',
  'onmis',
  'onnen',
  'onner',
  'onneu',
  'onnut',
  'onpas',
  'onslu',
  'onwis',
  'onzen',
  'onzer',
  'onzin',
  'ooert',
  'oogen',
  'oogst',
  'ooken',
  'oomes',
  'oomkc',
  'oomke',
  'oopke',
  'ooren',
  'ootje',
  'opdat',
  'opene',
  'opens',
  'ophad',
  'ophol',
  'opins',
  'opkom',
  'opmis',
  'oppas',
  'opree',
  'oprit',
  'opvat',
  'opvoe',
  'opvol',
  'opzat',
  'opzet',
  'order',
  'orgel',
  'oronn',
  'orreg',
  'orten',
  'ossen',
  'otter',
  'ottje',
  'ouden',
  'ouder',
  'ouste',
  'ouwen',
  'ouzeg',
  'ovent',
  'ovver',
  'ozzeg',
  'ozzen',
  'paail',
  'paard',
  'paark',
  'paars',
  'paart',
  'paast',
  'paauw',
  'pabbe',
  'pacht',
  'paden',
  'padie',
  'padje',
  'paild',
  'paket',
  'pakje',
  'pakte',
  'palen',
  'panne',
  'paole',
  'paolt',
  'paord',
  'paosk',
  'papke',
  'pappe',
  'papsk',
  'paren',
  'pasop',
  'paste',
  'pauze',
  'pazen',
  'pedde',
  'peerd',
  'peert',
  'pegel',
  'pehui',
  'pekei',
  'pekel',
  'pende',
  'penne',
  'pense',
  'peper',
  'perai',
  'perdu',
  'peren',
  'pette',
  'petuu',
  'peuld',
  'peule',
  'peune',
  'piano',
  'pidde',
  'piebe',
  'pieke',
  'piele',
  'pielk',
  'piene',
  'piepe',
  'piept',
  'pigge',
  'pijti',
  'pikje',
  'pikte',
  'pille',
  'pinze',
  'piont',
  'pioot',
  'piter',
  'pjtea',
  'pjter',
  'plaas',
  'plain',
  'plait',
  'plakk',
  'plank',
  'plant',
  'platt',
  'platz',
  'plaze',
  'plius',
  'ploag',
  'ploat',
  'plokt',
  'plomp',
  'plons',
  'ploug',
  'plukt',
  'plume',
  'plunt',
  'pluum',
  'pluus',
  'pntse',
  'poale',
  'poask',
  'pobbe',
  'podde',
  'podel',
  'poeke',
  'poepe',
  'poeps',
  'poest',
  'pogge',
  'poile',
  'polak',
  'polde',
  'polze',
  'pombe',
  'pomen',
  'pompe',
  'pooks',
  'poort',
  'poott',
  'popke',
  'poppe',
  'porce',
  'porde',
  'porre',
  'posie',
  'poten',
  'potje',
  'poule',
  'praai',
  'praam',
  'praan',
  'praat',
  'prach',
  'praim',
  'prane',
  'praol',
  'praom',
  'praot',
  'preek',
  'prees',
  'prent',
  'priem',
  'pries',
  'prijs',
  'prikt',
  'prins',
  'proam',
  'proat',
  'proef',
  'proek',
  'proel',
  'proem',
  'pronk',
  'pront',
  'prool',
  'prout',
  'proza',
  'prrrt',
  'pruit',
  'pruum',
  'psalm',
  'pudde',
  'pudel',
  'pulen',
  'punde',
  'putje',
  'puult',
  'pyren',
  'pyrer',
  'pĳter',
  'raabe',
  'raadt',
  'raais',
  'raait',
  'raand',
  'raang',
  'raank',
  'raasp',
  'raauw',
  'raden',
  'ragel',
  'ragen',
  'raikt',
  'raime',
  'raise',
  'raist',
  'raive',
  'raize',
  'raket',
  'ramen',
  'raode',
  'raokt',
  'raore',
  'raoto',
  'razen',
  'rebbe',
  'recht',
  'redde',
  'reden',
  'reeds',
  'reerd',
  'reere',
  'reeuw',
  'regel',
  'regen',
  'reide',
  'reien',
  'reine',
  'rekel',
  'reken',
  'rekte',
  'relds',
  'rende',
  'rente',
  'repen',
  'repte',
  'reren',
  'reten',
  'reube',
  'reupe',
  'reuze',
  'revel',
  'reven',
  'rezel',
  'rhein',
  'ribbe',
  'richt',
  'ridst',
  'riege',
  'rieke',
  'rieks',
  'riekt',
  'riemt',
  'riepe',
  'rieve',
  'rigao',
  'rigoa',
  'rijen',
  'rijke',
  'rijve',
  'rikoa',
  'rille',
  'ringd',
  'ringe',
  'rispe',
  'rnaor',
  'rneer',
  'rnien',
  'rnoar',
  'rnooi',
  'roads',
  'roakt',
  'roams',
  'roare',
  'roast',
  'roave',
  'robbe',
  'rodde',
  'roden',
  'roder',
  'roebe',
  'roege',
  'roeid',
  'roekt',
  'roelf',
  'roeme',
  'roene',
  'roepe',
  'roeps',
  'roept',
  'roert',
  'roest',
  'roete',
  'rogge',
  'roien',
  'roken',
  'rokje',
  'rolde',
  'rolle',
  'rompe',
  'ronde',
  'roode',
  'rooie',
  'rooij',
  'rookt',
  'room5',
  'rooms',
  'ropte',
  'rosie',
  'rosog',
  'rouer',
  'roulf',
  'roust',
  'rozen',
  'rozig',
  'ruden',
  'ruder',
  'rugge',
  'ruhig',
  'ruier',
  'ruive',
  'ruken',
  'rumen',
  'runde',
  'ruske',
  'ruste',
  'ruter',
  'ruzie',
  'saain',
  'saais',
  'saars',
  'sachs',
  'sagen',
  'sakte',
  'salon',
  'samen',
  'sammt',
  'sanft',
  'sante',
  'satan',
  'schaf',
  'schai',
  'schan',
  'schap',
  'schat',
  'schel',
  'schen',
  'schep',
  'scher',
  'scheu',
  'schie',
  'schij',
  'schik',
  'schil',
  'schip',
  'schoa',
  'schob',
  'schok',
  'schol',
  'schon',
  'schop',
  'schor',
  'schot',
  'schou',
  'schov',
  'schre',
  'schub',
  'schul',
  'schup',
  'schut',
  'schuw',
  'sebom',
  'sedan',
  'sedel',
  'seerd',
  'seese',
  'seeze',
  'sefie',
  'sefte',
  'segen',
  'seine',
  'sekun',
  'semoa',
  'senie',
  'setel',
  'sibbe',
  'siene',
  'sierd',
  'siert',
  'sietz',
  'sikke',
  'silon',
  'silot',
  'simon',
  'sinds',
  'sinee',
  'sirre',
  'sjars',
  'sjauw',
  'sjees',
  'sjene',
  'sjiek',
  'sjoar',
  'sjoen',
  'sjokt',
  'sjord',
  'sjout',
  'skoel',
  'slaab',
  'slaai',
  'slaan',
  'slaat',
  'slabe',
  'slagt',
  'slaif',
  'slait',
  'slaog',
  'slaop',
  'sleet',
  'slepe',
  'slept',
  'sleuf',
  'sleup',
  'slief',
  'sliek',
  'sliep',
  'slier',
  'sliet',
  'slikt',
  'slims',
  'slipp',
  'sloaf',
  'sloag',
  'sloap',
  'sloat',
  'slobe',
  'sloef',
  'sloeg',
  'sloek',
  'sloer',
  'slomp',
  'slont',
  'sloof',
  'sloop',
  'sloot',
  'slopt',
  'slorm',
  'sloug',
  'sluig',
  'sluip',
  'sluit',
  'sluug',
  'sluus',
  'sluut',
  'smaak',
  'smaal',
  'smakt',
  'smaok',
  'smart',
  'smeek',
  'smeer',
  'smeet',
  'smiet',
  'smoak',
  'smolt',
  'smook',
  'smoor',
  'smots',
  'smouk',
  'smuld',
  'snaor',
  'snaps',
  'snauw',
  'sneit',
  'snert',
  'snidt',
  'snits',
  'snoar',
  'snode',
  'snoef',
  'snoet',
  'snoft',
  'snokt',
  'snood',
  'snoof',
  'snort',
  'snouk',
  'snuut',
  'soage',
  'soagt',
  'sobat',
  'sodom',
  'soeie',
  'soest',
  'soeze',
  'some1',
  'somme',
  'soort',
  'spaar',
  'spaen',
  'spaik',
  'spand',
  'spans',
  'spant',
  'spats',
  'speet',
  'speit',
  'speld',
  'spelt',
  'speul',
  'spiek',
  'spiel',
  'spier',
  'spiet',
  'spije',
  'spijt',
  'spilk',
  'spint',
  'spits',
  'spoak',
  'spoan',
  'spoar',
  'spoed',
  'spoek',
  'spoel',
  'spoit',
  'spoor',
  'spork',
  'spouk',
  'sprak',
  'sprei',
  'sprek',
  'sprij',
  'sprik',
  'spril',
  'sprin',
  'sproa',
  'sprok',
  'spron',
  'sprut',
  'spuik',
  'spuil',
  'spuit',
  'staal',
  'staan',
  'staat',
  'stads',
  'stadt',
  'stain',
  'stait',
  'stale',
  'stand',
  'staol',
  'staon',
  'stapt',
  'starb',
  'stark',
  'start',
  'state',
  'steeg',
  'steek',
  'steem',
  'steen',
  'steht',
  'stekt',
  'steld',
  'stelt',
  'stemt',
  'stend',
  'stent',
  'sterk',
  'steun',
  'steur',
  'steut',
  'stief',
  'stieg',
  'stiel',
  'stien',
  'stiep',
  'stier',
  'stiet',
  'stijf',
  'stikt',
  'stoaf',
  'stoal',
  'stoan',
  'stoat',
  'stoed',
  'stoef',
  'stoek',
  'stoel',
  'stoep',
  'stoer',
  'stoet',
  'stoft',
  'stok-',
  'stokk',
  'stolt',
  'stomp',
  'stond',
  'stonn',
  'stons',
  'stoof',
  'stook',
  'stool',
  'stoop',
  'stoot',
  'stopt',
  'stork',
  'storm',
  'stort',
  'stoul',
  'stoup',
  'stove',
  'straf',
  'strak',
  'stree',
  'strek',
  'streu',
  'strik',
  'stroo',
  'strop',
  'strot',
  'strui',
  'strul',
  'stuit',
  'sturf',
  'sturm',
  'stuur',
  'stuut',
  'sujen',
  'suker',
  'sukke',
  'sunds',
  'sunte',
  'suzen',
  'swaai',
  'swait',
  'swalf',
  'swamp',
  'swans',
  'swebe',
  'sweep',
  'sweet',
  'swepe',
  'swien',
  'swiet',
  'swilk',
  'swoag',
  'swoai',
  'swoan',
  'swoar',
  'swoor',
  'swore',
  'swoul',
  'taail',
  'taain',
  'taalt',
  'taand',
  'taang',
  'taask',
  'taauw',
  'tafel',
  'tagen',
  'taisn',
  'takke',
  'talen',
  'tammo',
  'tange',
  'tante',
  'taoie',
  'taoka',
  'taoke',
  'taoko',
  'tappe',
  'tapte',
  'tarwe',
  'tatje',
  'tblad',
  'tebak',
  'teems',
  'teern',
  'tegen',
  'tegon',
  'tekst',
  'telde',
  'telen',
  'temee',
  'temet',
  'temoa',
  'tenen',
  'terde',
  'teren',
  'terog',
  'terop',
  'terug',
  'teste',
  'tetse',
  'teune',
  'tevre',
  'tgeld',
  'thais',
  'thans',
  'theek',
  'thoes',
  'thuil',
  'thuis',
  'thuus',
  'tiatd',
  'tibbe',
  'tieds',
  'tieke',
  'tiels',
  'tiene',
  'tiesk',
  'tiets',
  'tijde',
  'tikte',
  'tilde',
  'tille',
  'tinde',
  'tines',
  'tipke',
  'tisch',
  'titel',
  'tjams',
  'tjijs',
  'tjong',
  'tjont',
  'tjoop',
  'tkind',
  'tlief',
  'tneit',
  'toage',
  'toaij',
  'toald',
  'toale',
  'toart',
  'tobak',
  'tobbe',
  'tochi',
  'tocht',
  'todde',
  'toebe',
  'toede',
  'toege',
  'toeke',
  'toekt',
  'toene',
  'toest',
  'toeve',
  'toeze',
  'togen',
  'tokke',
  'tokus',
  'tolle',
  'tonen',
  'tonge',
  'tonie',
  'tonte',
  'topke',
  'toppe',
  'toren',
  'torke',
  'torze',
  'touge',
  'toven',
  'traan',
  'tragi',
  'tragt',
  'train',
  'trant',
  'traon',
  'trapt',
  'traud',
  'traut',
  'trauw',
  'trbie',
  'treds',
  'treft',
  'treif',
  'trekt',
  'treur',
  'trien',
  'trild',
  'triln',
  'trilt',
  'troan',
  'troef',
  'troep',
  'trokk',
  'troon',
  'trots',
  'troud',
  'trout',
  'trouw',
  'truus',
  'truut',
  'tsiik',
  'tudde',
  'tugen',
  'tuien',
  'tulen',
  'tumeg',
  'tumel',
  'tunen',
  'tunne',
  'turen',
  'turig',
  'tusie',
  'tutje',
  'tuurd',
  'twalm',
  'tweee',
  'tweie',
  'twief',
  'twieg',
  'twijd',
  'twije',
  'typen',
  'tzegd',
  'ulpen',
  'ummer',
  'under',
  'unser',
  'usten',
  'utern',
  'uudje',
  'uurke',
  'uutin',
  'vaail',
  'vaalg',
  'vaalk',
  'vaaln',
  'vaals',
  'vaalt',
  'vaarf',
  'vaast',
  'vader',
  'vaier',
  'vaige',
  'vaior',
  'vaird',
  'vaire',
  'valen',
  'valer',
  'valom',
  "van't",
  'vanaf',
  'vangt',
  'vaole',
  'vaort',
  'varen',
  'varfd',
  'varft',
  'vaste',
  'vaten',
  'vatte',
  'vedan',
  'vedde',
  'veegt',
  'veels',
  'veers',
  'vegen',
  'veger',
  'veier',
  'velen',
  'velke',
  'vends',
  'venne',
  'vereg',
  'verij',
  'verne',
  'veron',
  'verre',
  'verte',
  'vetst',
  'vette',
  'veuls',
  'viefe',
  'viege',
  'vierd',
  'vieve',
  'vijer',
  'vindt',
  'vinne',
  'viool',
  'visch',
  'viter',
  'vlaag',
  'vlage',
  'vlaig',
  'vlais',
  'vlaot',
  'vlees',
  'vleet',
  'vlent',
  'vliem',
  'vliet',
  'vlije',
  'vlijs',
  'vlijt',
  'vlint',
  'vloag',
  'vloer',
  'vlogg',
  'vlogt',
  'vlokt',
  'vloog',
  'vloot',
  'vloud',
  'vlugt',
  'vluik',
  'vluus',
  'voade',
  'voake',
  'voart',
  'voaze',
  'vocht',
  'voegt',
  'voele',
  'voenf',
  'voert',
  'voest',
  'vogel',
  'voier',
  'voile',
  'volde',
  'volgd',
  'volgt',
  'volks',
  'volle',
  'vonke',
  'voogd',
  'voold',
  'voort',
  'voren',
  'vorke',
  'vorkt',
  'vorlk',
  'vorst',
  'vorte',
  'voske',
  'voude',
  'vouer',
  'vouge',
  'vourt',
  'vraag',
  'vraaw',
  'vrage',
  'vragt',
  'vraid',
  'vrais',
  'vrang',
  'vraog',
  'vraus',
  'vrauw',
  'vrede',
  'vreef',
  'vrees',
  'vreet',
  'vreie',
  'vremd',
  'vrief',
  'vrien',
  'vries',
  'vrift',
  'vrije',
  'vrijf',
  'vrind',
  'vring',
  'vroag',
  'vroat',
  'vroeg',
  'vromd',
  'vrome',
  'vrong',
  'vroom',
  'vroor',
  'vroug',
  'vrouw',
  'vruig',
  'vrumd',
  'vrums',
  'vrund',
  'vrust',
  'vuier',
  'vuild',
  'vuilt',
  'vulen',
  'vurge',
  'waaid',
  'waait',
  'waale',
  'waalm',
  'waand',
  'waang',
  'waarf',
  'waark',
  'waarm',
  'wacht',
  'wadde',
  'wagen',
  'waide',
  'waige',
  'waigt',
  'waije',
  'waike',
  'waist',
  'walen',
  'wange',
  'waogd',
  'waogt',
  'waore',
  'waors',
  'waort',
  'waren',
  'warke',
  'warkt',
  'warme',
  'warmt',
  'warre',
  "was't",
  'waske',
  'wasse',
  'waste',
  'water',
  'watst',
  'watte',
  'wazen',
  'wedde',
  'weden',
  'weder',
  'weeft',
  'weegt',
  'weeke',
  'weeps',
  'weerd',
  'weers',
  'weert',
  'weest',
  'wegen',
  'weisz',
  'weken',
  'wekte',
  'welde',
  'welie',
  'welke',
  'welle',
  'wemig',
  'wende',
  'wenkt',
  'wenst',
  'weost',
  'wepeg',
  'wepel',
  'wepse',
  'weren',
  'werij',
  'werkt',
  'werpe',
  'werpt',
  'wesen',
  'weten',
  'weure',
  'weven',
  'wever',
  'wexen',
  "wez'n",
  'wezen',
  'wezig',
  'wicht',
  'widde',
  'wiede',
  'wiegt',
  'wieke',
  'wiele',
  'wielu',
  'wieme',
  'wiend',
  'wiens',
  'wient',
  'wierp',
  'wiert',
  'wiest',
  'wieve',
  'wieze',
  'wijgc',
  'wijst',
  'wijze',
  'wikko',
  'wikse',
  'wilde',
  'wilds',
  'wilko',
  'wille',
  'wilst',
  'winds',
  'winst',
  'wirze',
  'wiske',
  'wisse',
  'wiste',
  'witse',
  'witte',
  'wizze',
  'woade',
  'woage',
  'woagt',
  'woakt',
  'woale',
  'woard',
  'woare',
  'woart',
  'wodan',
  'woeps',
  'woerd',
  'woest',
  'wohnt',
  'wolde',
  'wolje',
  'wolle',
  'wollt',
  'wolst',
  'wonen',
  'woond',
  'woont',
  'woord',
  'woort',
  'worde',
  'wordt',
  'world',
  'worst',
  'worth',
  'wosse',
  'wotcr',
  'would',
  'wraid',
  'wring',
  'wuild',
  'wuilt',
  'wuirn',
  'wupke',
  'wurde',
  'wurms',
  'wuszt',
  'xeere',
  'xwien',
  'zaaid',
  'zaail',
  'zaait',
  'zaalf',
  'zaalm',
  'zaand',
  'zaark',
  'zaben',
  'zachs',
  'zacht',
  "zai't",
  'zaibe',
  'zaije',
  'zaike',
  'zaild',
  'zains',
  'zaipe',
  'zaken',
  'zakte',
  'zalig',
  'zalst',
  'zandt',
  'zaolt',
  'zarte',
  'zauuu',
  'zedde',
  'zeden',
  "zee'k",
  'zeeen',
  'zeelu',
  'zeere',
  'zeert',
  'zeese',
  'zeest',
  "zeg's",
  'zegde',
  'zegel',
  'zegen',
  'zegge',
  'zegse',
  'zegst',
  'zehrt',
  'zeide',
  'zeilt',
  'zejje',
  'zeker',
  'zekor',
  "zel'k",
  "zel't",
  'zelfs',
  'zelng',
  'zelst',
  'zelve',
  'zemel',
  'zemer',
  "zen'n",
  'zenen',
  'zesde',
  'zeten',
  'zetje',
  'zetst',
  'zette',
  'zeume',
  'zeurt',
  'zeven',
  'zezze',
  'zggen',
  'zicht',
  'ziede',
  'ziegt',
  'ziele',
  'ziezo',
  'zijde',
  'zijke',
  'zijne',
  'zijns',
  'zings',
  'zingt',
  'zinkt',
  'zitst',
  'zitte',
  'zoage',
  'zoake',
  'zocht',
  'zoekt',
  'zoele',
  'zoept',
  'zoere',
  'zoeze',
  'zogen',
  'zoien',
  'zokke',
  'zolde',
  'zolen',
  'zolfs',
  'zolln',
  'zolms',
  'zolst',
  'zomer',
  'zonde',
  'zonen',
  'zonne',
  "zoo'n",
  'zooal',
  'zooas',
  'zoooo',
  'zopen',
  'zorgd',
  'zorge',
  'zorgt',
  'zoudt',
  'zover',
  'zowat',
  'zucht',
  'zuden',
  'zuder',
  'zugen',
  'zugst',
  'zuide',
  'zuien',
  'zuijt',
  'zuikt',
  'zuion',
  'zuken',
  'zukke',
  'zulde',
  'zulke',
  'zulle',
  'zulsl',
  'zumen',
  'zunde',
  'zuneg',
  'zunig',
  'zunne',
  'zunog',
  'zupen',
  'zusje',
  'zuver',
  'zuzen',
  'zuzoi',
  'zuzui',
  'zwaai',
  'zwaar',
  'zwaip',
  'zwait',
  'zwang',
  'zwaor',
  'zwart',
  'zwebe',
  'zweeg',
  'zweep',
  'zweer',
  'zweet',
  'zwelt',
  'zwemt',
  'zwets',
  'zwieg',
  'zwien',
  'zwier',
  'zwoag',
  'zwoan',
  'zwoar',
  'zwoul',
]
